export default function ReviewCard({ name, text }: { name: string; text: string }) {
  return (
    <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="mb-4 flex text-[#f6b600]">
        {Array.from({ length: 5 }).map((_, index) => (
          <span key={index}>★</span>
        ))}
      </div>
      <p className="text-base leading-7 text-slate-700">“{text}”</p>
      <p className="mt-5 text-sm font-black uppercase tracking-[0.18em] text-[#0d4f12]">{name}</p>
    </article>
  );
}
